import React from 'react';
import { CSSObject } from '@emotion/react';
import { Get_Event_Features_And_SpeakersQuery as GetEventFeaturesAndSpeakersQuery } from '@graphql/gql/graphql';
import useBreakpoints from '@hooks/useBreakpoints';
import { hasDescriptionText, hasSpeakers } from './landingUtils';
import RichTextEventDescription from './RichTextEventDescription';

interface EventDescriptionProps {
  eventInfo: Pick<
    GetEventFeaturesAndSpeakersQuery['eventInfo'],
    'id' | 'title' | 'start' | 'end' | 'description' | 'speakers'
  >;
  numberOfLines?: number;
}

const useStyles = (hasSpeakersStyle = true, hasDescriptionStyle = true): Record<string, CSSObject> => {
  const { mediaIsMobile, mediaIsS, mediaIsM } = useBreakpoints();

  return {
    callToActionPreLoginContainer: {
      display: 'flex',
      marginTop: !hasDescriptionStyle ? 0 : 40,
      button: {
        svg: {
          marginLeft: 0
        }
      },
      flexDirection: 'row',
      alignItems: 'center',
      [mediaIsMobile]: {
        marginTop: !hasDescriptionStyle ? 0 : 32
      },
      [mediaIsS]: {
        marginTop: !hasDescriptionStyle ? 0 : 32,
        flexDirection: hasSpeakersStyle ? 'column' : 'row',
        alignItems: hasSpeakersStyle ? 'start' : 'center'
      },
      [mediaIsM]: {
        flexDirection: hasSpeakersStyle ? 'column' : 'row',
        alignItems: hasSpeakersStyle ? 'start' : 'center'
      }
    },
    callToActionButtonPreAuthContainer: {
      marginRight: 20,
      marginBottom: 0,
      [mediaIsMobile]: {
        marginRight: 0
      },
      [mediaIsS]: {
        marginRight: 0,
        marginBottom: hasSpeakersStyle ? 24 : 0
      },
      [mediaIsM]: {
        marginBottom: hasSpeakersStyle ? 24 : 0
      }
    },
    cancelledEventTag: {
      marginBottom: 10
    },
    richTextDescriptionContainer: {
      [mediaIsMobile]: {
        padding: null
      }
    }
  };
};

function EventDescription({ eventInfo, numberOfLines = 5 }: EventDescriptionProps): JSX.Element {
  const hasDescription = hasDescriptionText(eventInfo);
  const hasSpeakersArray = hasSpeakers(eventInfo.speakers);
  const { richTextDescriptionContainer } = useStyles(hasSpeakersArray, hasDescription);

  return (
    <>
      {hasDescription && (
        <RichTextEventDescription
          eventDescription={eventInfo.description}
          customContainerStyle={richTextDescriptionContainer}
          enableExpandableDescription
          numberOfLines={numberOfLines}
        />
      )}
    </>
  );
}

export default EventDescription;
